import { requestApi } from 'utils';

export const attendInsuranceCooperationApiRequest = ({ insuranceNumber, offerId, userMetaData }, bearerToken) => {
  const headers = {
    'Content-Type': 'application/json; charset=UTF-8',
    Accept: 'application/json',
    'X-Authorization': `Bearer ${bearerToken}`
  };

  const variables = {
    insuranceNumber: null,
    offerId,
    dateOfBirth: null,
    companyName: null,
    code: null
  };

  if (!!`${insuranceNumber || ''}`.trim()) {
    variables.insuranceNumber = insuranceNumber;
  }
  if (!!userMetaData?.dateOfBirth) {
    variables.dateOfBirth = userMetaData.dateOfBirth;
  }
  if (!!userMetaData?.gender) {
    variables.gender = userMetaData.gender;
  }
  if (!!userMetaData?.age) {
    variables.age = parseInt(`${userMetaData.age}`, 10);
  }
  if (!!userMetaData?.company || !!userMetaData?.companyName) {
    variables.companyName = userMetaData.company || userMetaData.companyName;
  }
  if (!!userMetaData?.code || !!userMetaData?.code) {
    variables.code = userMetaData.code;
  }

  return requestApi.request({
    headers,
    data: {
      variables,
      query: `
        mutation AttendZppCourseOffer($offerId: String!, $insuranceNumber: String, $dateOfBirth: ISO8601Date, $companyName: String, $gender: Gender, $age: Int, $code: String) {
          attendZppCourseOffer(offerId: $offerId, insuranceNumber: $insuranceNumber, dateOfBirth: $dateOfBirth, companyName: $companyName, gender: $gender, age: $age, code: $code) {
            user {
              id
              email
              firstName
              b2bClientKeys
            }
          }
        }
      `
    }
  });
};
